export default __webpack_public_path__ + "static/media/highlight_skill_7.47d87839.svg";